module.exports = __webpack_public_path__ + "img/transporeon-logo.75efd6b3.svg";